export default __webpack_public_path__ + "static/media/14.36e2a254.png";